import DOMPurify from 'dompurify';

export default {
  computed: {
    sanitizedContent() {
      const ALLOWED_ATTR = ['href', 'target', 'class', 'id', 'style', 'src'];
      const ALLOWED_TAGS = ['a', 'div', 'span', 'strong', 'p', 'b', 'i', 'ul', 'li', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br', 'img'];
      return (content) => DOMPurify.sanitize(content, { ALLOWED_TAGS, ALLOWED_ATTR });
    },
  },
};
